import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AccountPasswordDialogComponent } from "./account-password-dialog.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzButtonModule } from "ng-zorro-antd/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [AccountPasswordDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzModalModule,
    NzButtonModule,
    FormsModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    ReactiveFormsModule,
  ],
  exports: [AccountPasswordDialogComponent],
})
export class AccountPasswordDialogModule {}
